// extracted by mini-css-extract-plugin
export var content = "ProductDetails-module--content--1MHGr";
export var detailsCloseIcon = "ProductDetails-module--detailsCloseIcon--1DOpV";